import {
  BrowserMessageReceiveType,
  BrowserMessageType,
  registerElectronMessageReceiver,
  sendElectronMessage,
} from 'electron-communication-lib/BrowserForApp';
import {useMountEffect} from 'webapp-lib/utils';

export function useHandlePing(): void {
  useMountEffect(() => {
    registerElectronMessageReceiver(BrowserMessageReceiveType.PING, handlePing);
  });
}

function handlePing() {
  sendElectronMessage({
    type: BrowserMessageType.PONG,
    payload: null,
  });
}
